import * as Sentry from '@sentry/react';

const normalizeError = (error: unknown): Error => {
    if (error instanceof Error) {
        return error;
    }

    if (typeof error === 'string') {
        return new Error(error);
    }

    return new Error('Unknown error captured');
};

export const initSentry = () => {
    const dsn = window._env_?.SENTRY_DSN;
    if (!dsn) {
        return;
    }

    Sentry.init({
        dsn,
        environment: window._env_?.ENV,
    });
};

export const captureError = (
    error: unknown,
    context?: Sentry.CaptureContext,
) => {
    Sentry.captureException(normalizeError(error), context);
};
